import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import { experimentalStyled as styled } from "@mui/material/styles";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Badge,
  Divider,
  IconButton,
  MenuItem,
  Modal,
  Paper,
  Tooltip,
  Typography,
  Button,
} from "@mui/material";
import Logo from "../assets/Logo.png";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ViewCompactIcon from "@mui/icons-material/ViewCompact";
import secureLocalStorage from "react-secure-storage";
import CloseIcon from "@mui/icons-material/Close";
import SaveOutlined from "@mui/icons-material/SaveOutlined";
import { Link } from "../host/host";
import { Link as Linked } from "react-router-dom";
import AvatarEditor from "react-avatar-editor";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import axios from "axios";
import DialogTitle from "@mui/material/DialogTitle";
// import "./header.css";
import { updateUser } from "../actions/user";
import toast from "react-hot-toast";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};
export default function Header() {
  const [anchorElUser1, setAnchorElUser1] = React.useState(null);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));
  const imgUrl = `${Link}/user-profile-image/${user?.results?.img}`;
  const [image, setImage] = React.useState(imgUrl);
  const [editor, setEditor] = React.useState(imgUrl);
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  const handleImageChange = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    setEditor(URL.createObjectURL(file));
    setImage(file);
  };

  const handleSaveImage = async () => {
    if (editor) {
      const formData = new FormData();

      // Check if user and user.results? are defined before accessing email
      if (user && user.results && user.results?.email) {
        formData.append("email", user.results?.email);
      }

      formData.append("photo", image);
      try {
        await axios.patch(
          `${Link}/api/v1/users/update-user/info/${user?.results?._id}`,
          formData,
          {
            headers: {
              enctype: "multipart/form-data",
            },
          }
        );
        alert("profile image updated");
      } catch (error) {}
    }
  };

  const cancelImageChange = () => {
    setImage(imgUrl);
    setEditor(imgUrl);
    handleDialogClose();
  };
  const handleOpenUserMenu1 = (event) => {
    setAnchorElUser1(event.currentTarget);
  };
  const handleCloseUserMenu1 = () => {
    setAnchorElUser1(null);
  };

  const [anchorElUser2, setAnchorElUser2] = React.useState(null);
  const handleOpenUserMenu2 = (event) => {
    setAnchorElUser2(event.currentTarget);
  };
  const handleCloseUserMenu2 = () => {
    setAnchorElUser2(null);
  };
  const [ModalOpen, setModalOpen] = React.useState(false);
  const handleOpen = () => {
    setModalOpen(true);
  };
  const handleClose = () => {
    setModalOpen(false);
  };
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    textAlign: "center",
  }));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logout = () => {
    let loggingOutId;
    loggingOutId = toast.loading("Please wait we logging you out");
    dispatch(updateUser(user?.results._id, { login: "no", system: "none" }));
    setTimeout(() => {
      dispatch({ type: "LOGOUT" });
      navigate("/claim/login");
      toast.remove(loggingOutId);
    }, 2000);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <BootstrapDialog
        style={{ margin: "auto", width: "400px" }}
        onClose={handleDialogClose}
        aria-labelledby='customized-dialog-title'
        open={openDialog}>
        <DialogTitle sx={{ m: 0, p: 1 }} id='customized-dialog-title'>
          eClaim Account
        </DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleDialogClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}>
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Typography>Profile Picture</Typography>
        </DialogContent>
        <DialogContent>
          <Typography style={{ fontSize: "12px" }}>
            A picture helps people recognize you and lets you know when you’re
            logged in to your account
          </Typography>
        </DialogContent>
        <DialogContent
          dividers
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          {image && (
            <AvatarEditor
              ref={(ref) => setEditor(ref)}
              image={image}
              width={150}
              height={150}
              border={10}
            />
          )}
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}>
          <input type='file' accept='image/*' onChange={handleImageChange} />

          <Button
            type='file'
            style={{ backgroundColor: "#ffffff", color: "#fff" }}
            startIcon={<SaveOutlined />}
            size='small'
            autoFocus
            onClick={handleSaveImage}>
            Save
          </Button>
          <Button
            style={{ color: "red" }}
            size='small'
            onClick={cancelImageChange}>
            Cancel
          </Button>
        </DialogActions>
        <span style={{ fontSize: "10px" }}>
          upload passport sized picture (recommended)
        </span>
        <em style={{ fontSize: "10px" }}>
          NB: profile picture will change after reload
        </em>
      </BootstrapDialog>
      <Modal
        open={ModalOpen}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box
          sx={style}
          style={{ backgroundColor: "#dfdfdf" }}
          className='animate__animated animate__pulse'>
          <Typography id='modal-modal-title' variant='h6' component='h2'>
            Logout Confirmation
          </Typography>
          <Typography style={{ marginTop: "10px", fontWeight: "bold" }}>
            {user?.results?.firstName + " " + user?.results?.lastName}
          </Typography>
          <Typography
            id='modal-modal-description'
            sx={{ mt: 2, marginBottom: "20px" }}>
            Are You Sure You Want To Exit?
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}>
            <Button
              style={{ backgroundColor: "#303846" }}
              onClick={logout}
              size='small'
              variant='contained'>
              Yes <CheckIcon />
            </Button>
            <Button
              color='error'
              className='btn-danger'
              size='small'
              onClick={handleClose}
              variant='contained'>
              CANCEL <CancelIcon />
            </Button>
          </div>
        </Box>
      </Modal>
      <AppBar
        elevation={0}
        position='fixed'
        style={{
          backgroundColor: "#2C3E50",
          backgroundFilter: "blur(10px)",
          height: "60px",
          backdropFilter: "blur(10px)",
        }}>
        <Box
          style={{
            marginTop: "7px",
            marginLeft: 100,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginTop: "-15px",
            }}>
            <img
              width={50}
              height={"auto"}
              src={Logo}
              alt='src logo'
              style={{ marginTop: "10px", marginLeft: "170px" }}
            />
            <Typography>
              <Linked
                style={{
                  color: "#ccc",
                  marginLeft: "10px",
                  marginRight: "10px",
                  fontSize: "20px",
                  textDecoration: "none",
                }}
                to={"/claim/"}>
                Bosome Freho Rural Bank PLC.
              </Linked>
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-around",
            }}>
            <Tooltip title='click to logout'>
              <IconButton onClick={handleOpen}>
                <LogoutIcon style={{ color: "#ccc" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title='sFass Apps'>
              <IconButton onClick={handleOpenUserMenu2}>
                <ViewCompactIcon style={{ fontSize: "30px", color: "#ccc" }} />
              </IconButton>
            </Tooltip>
            <Badge color='secondary' badgeContent={0} max={100}>
              <Tooltip title='Toggle notifications panel'>
                <IconButton onClick={handleOpenUserMenu1}>
                  <NotificationsIcon style={{ color: "#ccc" }} />
                </IconButton>
              </Tooltip>
            </Badge>
            <Typography>
              <strong style={{ color: "#ccc ", fontSize: "20px" }}>BRB.</strong>
              <em style={{ color: "#ccc" }}>eClaim</em>
            </Typography>
          </div>
        </Box>
        <Menu
          sx={{ mt: "45px" }}
          id='menu-appbar'
          anchorEl={anchorElUser1}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser1)}
          onClose={handleCloseUserMenu1}>
          <MenuItem style={{ display: "flex", flexDirection: "column" }}>
            <Typography>Notifications</Typography>
          </MenuItem>
          <Divider />
          <MenuItem style={{ display: "flex", flexDirection: "column" }}>
            <Typography>No messages available</Typography>
          </MenuItem>
        </Menu>
        <Menu
          sx={{ mt: "45px" }}
          id='menu-appbar'
          anchorEl={anchorElUser2}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser2)}
          onClose={handleCloseUserMenu2}
          style={{}}>
          <Paper
            elevation={0}
            style={{
              width: "240px",
              padding: "10px",
              overflow: "hidden",
              height: "400px",
            }}>
            <Typography variant='h5'>Apps</Typography>
            <Divider style={{ marginBottom: "40px" }} />

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3,1fr)",
                gap: "15px",
              }}>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <Typography>sFasss</Typography>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${Link}/assets-register`}
                  target='_blank'
                  rel='noreferrer'>
                  Assets Register
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${Link}/reconciliation`}
                  target='_blank'
                  rel='noreferrer'>
                  Reconciliation
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${Link}/stock`}
                  target='_blank'
                  rel='noreferrer'>
                  Stock manager
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${Link}/investment`}
                  target='_blank'
                  rel='noreferrer'>
                  Portfolio Manager
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>

                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${Link}/advice`}
                  target='_blank'
                  rel='noreferrer'>
                  eAdvice
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>

                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${Link}/claim`}
                  target='_blank'
                  rel='noreferrer'>
                  eClaim
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={`${Link}/insurance`}
                  target='_blank'
                  rel='noreferrer'>
                  Risk Manager
                </a>
              </Item>
            </div>
          </Paper>
        </Menu>
      </AppBar>
    </Box>
  );
}
